import Loadable from "app/components/Loadable";
import { lazy } from "react";

const SeatsPage = Loadable(lazy(() => import("./SeatsPage")));

const seatRoutes = [
  { path: "seats", element: <SeatsPage /> },
];

export default seatRoutes;
